import Appbar from 'components/appbar/Appbar';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import React from 'react';
import ProcedureAction from './ProcedureAction';
import { useFetchProcedures } from './hooks/useFetchProcedures';
import ProcedureFilterBox from './ProcedureFilterBox';
import PaginationProvider from 'hooks/pagination';
import { useDisplayMode } from 'hooks/useDisplayMode';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import NoData from 'components/no-data/NoData';
import ProcedureListTable from './list/table/ProcedureListTable';
import Pagination from 'components/pagination/Pagination';
import ProcedureListModule from './list/module/ProcedureListModule';

const Procedure: React.FC = () => {
  const {
    procedures,
    loading,
    handleSearch,
    filter,
    handleChange,
    handleSort,
    orderedIndex,
    setPage,
    setRows,
    page,
    rows,
    total,
  } = useFetchProcedures();
  const [displayMode] = useDisplayMode();

  return (
    <>
      <Appbar title="Consultas" ActionsComponent={<ProcedureAction />} />
      <PageHeaderActions
        title="Consultas"
        description="Gestão de consultas"
        ActionComponent={<NewRecordButton label="Nova consulta" to="/consultation/new" />}
      />

      <ProcedureFilterBox loading={loading} handleChange={handleChange} filter={filter} handleSearch={handleSearch} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : procedures.length === 0 ? (
          <NoData message="Nenhuma consulta encontrada" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <ProcedureListTable procedures={procedures} />
            ) : (
              <ProcedureListModule procedures={procedures} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Procedure;
